import {observer} from "mobx-react-lite";
import React from "react";
import {Modulator} from "../stores/Modulator";
import {ModulatorHeader} from "./ModulatorHeader";
import {ModulatorWave} from "./ModulatorWave";
import {ModulatorControls} from "./ModulatorControls";
import {WaveSelector} from "./WaveSelector";
import "./ModulatorWrapper.css";

interface ModulatorWrapperProps {
    modulator: Modulator;
    index: number;
}

export const ModulatorWrapper = observer(({modulator, index}: ModulatorWrapperProps) => {

    return (
        <div className="modulator bg padded border-t border-b">
            <ModulatorHeader modulator={modulator} index={index} />
            <div className="row">
                <WaveSelector modulator={modulator} />
                <ModulatorWave modulator={modulator} />
                <ModulatorControls modulator={modulator} index={index} />
            </div>
        </div>
    );

});
